// Packages
import { Component } from "react";
import { Link } from "react-router-dom";

// views
import SchoolAdminDashboard from "./schoolAdminDashboard";

// Assets
import upArrow from "../../assets/images/up-arrow.png";
import close from "../../assets/images/crosstick.png";

// materail Ui
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import search from "../../assets/images/searchIcon.png";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { BsXLg } from "react-icons/bs";

class uploadInProgress extends Component {
  constructor() {
    super();
    this.state = {
      checkedBox: false,
      // value: 'event',
      open: false,
      isShareData: false,
    };
  }
  handleChange = (name) => (event) => {
    this.setState({ [name]: event.target.checked });
  };
  handleRadioChange = (event) => {
    this.setState({ value: event.target.value });
  };
  openDialog() {
    this.setState({ open: true });
  }
  closeDialog() {
    this.setState({ open: false });
  }

  render() {
    const { isShareData } = this.state;
    return (
      <div>
        <SchoolAdminDashboard />
        <div className="margin-auto">
          <section className="contact-section">
            <div className="row">
              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                <div className="grid">
                  <div className="row mt-40">
                    <div className="col-4 col-sm-4 col-md-4 col-lg-4 plr">
                      <img src={upArrow} alt="Video"></img>
                      <label className="ml-2 fs-20 bold">
                        Upload In Progress
                      </label>
                    </div>
                    <div className="col-3 col-sm-3 col-md-3 plr col-lg-3 text-right">
                      <Link to="/browsecomputer">
                        <label className="fs-18 semi-bold dblack cp">
                          <u>Cancel Upload</u>
                        </label>
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-8 col-md-8 col-lg-8">
                    <div className="uploadDocuments-card">
                      <div className="row">
                        <div className="col-6 col-sm-6 col-md-6 col-lg-6 plr">
                          <label className="ml-2 semi-bold fs-18 fmlabel">
                            3% … 1 of 365 files uploaded
                          </label>
                          <div className="ml-2 bold fs-18 ">25 MB / 977 MB</div>
                        </div>
                        <div className="col-6 col-sm-6 col-md-6 col-lg-6 plr text-right">
                          <button className="semi-bold greybtn">
                            Upload another angle
                          </button>
                        </div>
                      </div>
                      <div className="clear40"></div>
                    </div>
                  </div>
                  <div className=" col-sm-4 col-md-4 col-lg-4">
                    {isShareData ? (
                      <div className="uploadDocuments-card">
                        <div className="row">
                          <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                            <button className="shareto">
                              Share with all the coaches
                            </button>
                            <div className="clear10"></div>
                            <p className="medium fs-16 fmlabel">
                              Sharing will email the video link.
                            </p>
                            <p className="bold fs-20 ">OR</p>
                            <div>
                              <div className="row">
                                <div className="col-lg-8">
                                  <input
                                    type="text"
                                    placeholder="Search Coaches name"
                                    name="search"
                                    className="form-control medium "
                                  ></input>
                                </div>

                                <div className="col-lg-4">
                                  <select
                                    className="form-control bold"
                                    placeholder=""
                                  >
                                    <option>ALL</option>
                                    <option></option>
                                    <option></option>
                                  </select>
                                </div>
                              </div>
                              <div className="clear10"></div>
                              <div className="row">
                                <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                  <table className="table ">
                                    <tbody>
                                      <tr>
                                        <td>
                                          <div className="custom-control custom-checkbox">
                                            <input
                                              type="checkbox"
                                              className="custom-control-input"
                                              id="customCheck1"
                                            ></input>
                                            <label
                                              className="custom-control-label semi-bold fs-18"
                                              htmlFor="customCheck1"
                                            >
                                              Ross Taylor
                                            </label>
                                          </div>
                                        </td>
                                        <td className="fmlabel medium text-right">
                                          Coach
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <div className="custom-control custom-checkbox">
                                            <input
                                              type="checkbox"
                                              className="custom-control-input"
                                              id="customCheck2"
                                            ></input>
                                            <label
                                              className="custom-control-label semi-bold fs-18"
                                              htmlFor="customCheck2"
                                            >
                                              Kane Riche
                                            </label>
                                          </div>
                                        </td>
                                        <td className="fmlabel medium text-right">
                                          Head Coach
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <div className="custom-control custom-checkbox">
                                            <input
                                              type="checkbox"
                                              className="custom-control-input semi-bold"
                                              id="customCheck3"
                                            ></input>
                                            <label
                                              className="custom-control-label semi-bold fs-18"
                                              htmlFor="customCheck3"
                                            >
                                              Kane Riche
                                            </label>
                                          </div>
                                        </td>
                                        <td className="fmlabel medium text-right">
                                          Coach
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <div className="custom-control custom-checkbox">
                                            <input
                                              type="checkbox"
                                              className="custom-control-input semi-bold fs-18"
                                              id="customCheck4"
                                            ></input>
                                            <label
                                              className="custom-control-label fs-18 semi-bold"
                                              htmlFor="customCheck4"
                                            >
                                              Kane Riche
                                            </label>
                                          </div>
                                        </td>
                                        <td className="fmlabel medium text-right">
                                          Head Coach
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                            <div className="clear10"></div>
                            <button
                              className="shareto"
                              onClick={this.openDialog.bind(this)}
                            >
                              Share with all the coaches
                            </button>
                            <Dialog
                              id="dialog"
                              open={this.state.open}
                              onEnter={console.log("Hey.")}
                            >
                              <DialogTitle>
                                <div className="row">
                                  <div className="col-6">
                                    <div className="bold fs-20">
                                      Share Videos on Email
                                    </div>
                                  </div>
                                  <div className="col-6 text-right">
                                    <BsXLg
                                      onClick={this.closeDialog.bind(this)}
                                      className="crossview cp"
                                       />
                                  </div>
                                </div>
                              </DialogTitle>
                              <DialogContent>
                                <div>
                                  <div className="input-group mb-3">
                                    <input
                                      type="text"
                                      className="form-control medium"
                                      placeholder="https://contendzone.ca/uploaded videos"
                                      aria-describedby="basic-addon2"
                                    ></input>
                                    <div class="input-group-append">
                                      <span
                                        className="input-group-text"
                                        id="basic-addon2"
                                      >
                                        <img src={search} alt="" />
                                      </span>
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="col-6">
                                      <label className="fmlabel">
                                        5 coaches are selected
                                      </label>
                                    </div>
                                    <div className="col-6 text-right">
                                      <button
                                        onClick={this.closeDialog.bind(this)}
                                        className="saveBtn fs-16 cp"
                                      >
                                        Send
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </DialogContent>
                            </Dialog>
                            <div className="clear20"></div>
                            <p className="medium fs-16 fmlabel">
                              5 coaches are selected
                            </p>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="uploadDocuments-card">
                        <div className="row">
                          <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                            <label className="ml-2 medium fs-16 fmlabel">
                              Select Event
                            </label>
                            <select
                              className="form-control bold"
                              placeholder=""
                            >
                              <option>Select</option>
                              <option></option>
                              <option></option>
                            </select>
                          </div>
                        </div>
                        <div className="clear30"></div>
                        <div className="row">
                          <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                            <label className="ml-2 medium fs-16 fmlabel">
                              Category
                            </label>
                            <br></br>
                            <FormControl
                              component="fieldset"
                              className="fmlabel "
                            >
                              <RadioGroup
                                aria-label="Category"
                                name="Category"
                                value={this.state.value}
                                onChange={this.handleRadioChange}
                              >
                                <FormControlLabel
                                  value="event"
                                  control={<Radio />}
                                  label="Event"
                                />
                                <FormControlLabel
                                  value="practice"
                                  control={<Radio />}
                                  label="Practice Game"
                                />
                                <FormControlLabel
                                  value="scout"
                                  control={<Radio />}
                                  label="Scout"
                                />
                              </RadioGroup>
                            </FormControl>
                          </div>
                        </div>
                        <div className="clear30"></div>
                        <div className="row">
                          <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                            <label className="ml-2 medium fs-16 fmlabel">
                              Playlist Name
                            </label>
                            <input
                              className="form-control medium"
                              placeholder="Enter playlist name"
                            ></input>
                          </div>
                        </div>
                        <div className="clear30"></div>
                        <div className="row">
                          <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                            <button className="saveBtn fs-16 mr-2">Save</button>
                            <button
                              className="sharebtn fs-16"
                              onClick={(e) =>
                                this.setState({ isShareData: !isShareData })
                              }
                            >
                              Share
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    );
  }
}
export default uploadInProgress;
